module.exports = __webpack_public_path__ + "img/pop_bg.0678f68b.jpg";